import { isBrowser, isDevelopment } from '@websolutespa/bom-core';
import React from 'react';

export const accessibility = async (App: typeof React, config?: Record<string, unknown>): Promise<void> => {
  if (isDevelopment && isBrowser) {
    const axe = await import('@axe-core/react');
    const ReactDOM = await import('react-dom');
    axe.default(App, ReactDOM, 1000, config);
  }
};
